/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {openSingleFold, dmsPurchaseList, getReportType} from '../../service/reportForm';

class DiscountStatements extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            opts: ['开单含折让报表'],
            key: 0,
            channelCode: this.channelId,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dateMapTotal: 0,
            searchObj: {
                salesChannelCode: this.channelId,
                orderedDateBegin: '',
                orderedDateEnd: '',
                orderNumber: '',
                salesUnitId: '',
                itemDesc: '',
                itemNum: '',
                type: '',
                s: 10,
                p: 1,
                proLine: ''
            },
            salesUnitOptions: [],
            reportTypeOptions: [],
            loading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goAdd() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/orderReport/exportExcel`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                salesChannelCode: this.channelId,
                orderedDateBegin: '',
                orderedDateEnd: '',
                orderNumber: '',
                salesUnitId: '',
                itemDesc: '',
                itemNum: '',
                type: '',
                s: 10,
                p: 1,
                proLine: ''
            }
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.orderedDateBegin || this.state.searchObj.orderedDateBegin == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.orderedDateEnd || this.state.searchObj.orderedDateEnd == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderedDateBegin: value.from,
                    orderedDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        this.setState({
            loading: true
        });
        openSingleFold(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    rows: result.data || [],
                    total: result.total,
                    dateMapTotal: result.dataMap ? result.dataMap.total : 0,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                self.setState({
                    loading: false
                });
            }
        });
    }

    componentWillMount() {
        dmsPurchaseList({channelCode: this.state.channelCode, s: 999}).then(res => {
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.setState({salesUnitOptions: arr})
            }
        });
        getReportType({
            sKey: 'ORDER_REPORT_TYPE'
        }).then(res => {
            if (res.code === 200) {
                const data = res.data || [];
                const arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                data.forEach(item => {
                    arr.push({
                        text: item.name,
                        value: item.name
                    })
                });
                this.setState({reportTypeOptions: arr})
            }
        })
    }

    componentDidMount() {
        // this.initData();
    }

    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            selectedRowKeys,
            salesUnitOptions,
            reportTypeOptions,
            dateMapTotal,
            loading
        } = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'date',
                    label: '登记日期',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderedDateBegin || '',
                        end: searchObj.orderedDateEnd || ''
                    }
                }, {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '选择购货单位',
                    options: salesUnitOptions,
                    multiple: false,
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.salesUnitId
                }, {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '请输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                }, {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '请输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                }, {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                }, {
                    name: 'type',
                    label: '类型',
                    text: '选择物料类型',
                    options: reportTypeOptions,
                    defaultValue: searchObj.type,
                    multiple: false,//支持多选
                    type: 'select'
                }, {
                    name: 'proLine',
                    label: '产品线',
                    text: '选择产品线',
                    options: [
                        {value: '', text: '全部'},
                        {value: '01', text: '元器件'},
                        {value: '02', text: '电工'},
                        {value: '03', text: '电表'},
                        {value: '04', text: '变频器'},
                        {value: '05', text: '天e'},
                        {value: '06', text: 'TG精品'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.proLine
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,
            rowKey: 'RN',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 3000, y: false},
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'ORDERNUMBER',
                }, {
                    title: '订单类型',
                    dataIndex: 'ORDERTYPE',
                }, {
                    title: '付款条件',
                    dataIndex: 'PAYMENT',
                }, {
                    title: '类型',
                    dataIndex: 'TYPE',
                }, {
                    title: '订单状态',
                    dataIndex: 'ORDERSTATUS'
                }, {
                    title: '录入日期',
                    dataIndex: 'ORDEREDDATE',
                }, {
                    title: '登记日期',
                    dataIndex: 'BOOKEDDATE',
                }, {
                    title: '物料编码',
                    dataIndex: 'ITEMNUM',
                }, {
                    title: '物料说明',
                    dataIndex: 'ITEMDESC',
                    width: 200
                }, {
                    title: '系列',
                    dataIndex: 'DETAILCAT',
                }, {
                    title: '购货单位',
                    dataIndex: 'SALESUNITNAME',
                }, {
                    title: '数量',
                    dataIndex: 'QUANTITY',
                }, {
                    title: '牌价',
                    dataIndex: 'UNITLISTPRICE',
                }, {
                    title: '牌价金额',
                    dataIndex: 'LISTAMOUNT',
                }, {
                    title: '基础下浮',
                    dataIndex: 'JCXF',
                }, {
                    title: '基础下浮价',
                    dataIndex: 'JCXFJ',
                }, {
                    title: '基础下浮金额',
                    dataIndex: 'JCXFAMOUNT',
                }, {
                    title: '签约下浮额',
                    dataIndex: 'QYXFE',
                }, {
                    title: '最终下浮率',
                    dataIndex: 'ZZXF',
                }, {
                    title: '销售单价',
                    dataIndex: 'UNITSELLINGPRICE',
                }, {
                    title: '销售金额',
                    dataIndex: 'SELLINGAMOUNT',
                }, {
                    title: '销售金额(考核)',
                    dataIndex: 'ORDERAMOUNTKH',
                }, {
                    title: '返利结算基数',
                    dataIndex: 'FLCK',
                }, {
                    title: '特价追加',
                    dataIndex: 'TJZJ',
                }, {
                    title: '销售折让',
                    dataIndex: 'XSZR',
                }, {
                    title: '促销追加',
                    dataIndex: 'CXZJ',
                }, {
                    title: '促销大点',
                    dataIndex: 'CXDD',
                }, {
                    title: '推广折让',
                    dataIndex: 'TGZR',
                }, {
                    title: '特殊订单折让',
                    dataIndex: 'TSDDZR',
                }, {
                    title: '退货扣点',
                    dataIndex: 'THKD',
                }, {
                    title: '产品大类',
                    dataIndex: 'ABCTYPE',
                }, {
                    title: '产品类别',
                    dataIndex: 'DETAILTYPE',
                }, {
                    title: '发运日期',
                    dataIndex: 'SHIPPEDDATE',
                }, {
                    title: '发运数量',
                    dataIndex: 'SHIPPEDQUANTITY',
                }, {
                    title: '发运状态',
                    dataIndex: 'SHIPPEDSTATUS',
                }, {
                    title: '业务类型',
                    dataIndex: 'BUSINESSTYPE',
                }, {
                    title: '经销商分类',
                    dataIndex: 'DEALERCATEGORY',
                }, {
                    title: '库存属性',
                    dataIndex: 'STOCKTYPE',
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goAdd.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps} />
                <p>销售金额合计：{dateMapTotal}</p>
            </div>
        </div>
    }
}

export default withRouter(DiscountStatements);



// WEBPACK FOOTER //
// ./src/routes/reportForm/discountStatements.js